import { useCallback, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGetOneLiveDetailPeopleByUserId } from '../../../hooks/queries/lives/lives/use-get-one-live-detail-people-by-user-id'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'

export function useUpdateUserLivePoints() {
  const [points, setPoints] = useState(0)

  const liveId = useGlobalStore(useShallow((state) => state.liveId))
  const liveUserId = useGlobalStore(useShallow((state) => state.liveUserId))

  const { oneDetailPeople } = useGetOneLiveDetailPeopleByUserId(
    liveUserId as number,
  )

  const setPointsUserLive = useCallback(
    ({ message }: LiveGiftsAnimations) => {
      const usersReturns = message?.returnForUser?.flatMap(
        ({ returnForUser }) => {
          return returnForUser
        },
      )

      const newPoints = usersReturns?.find((item) => item.userId === liveUserId)

      setPoints((prevState) => prevState + (newPoints?.value || 0))
    },
    [liveUserId],
  )

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: setPointsUserLive,
  })

  return {
    points: points || (oneDetailPeople?.points ?? 0),
  }
}
